import { render, staticRenderFns } from "./AEicon.vue?vue&type=template&id=fe98c8f0"
import script from "./AEicon.vue?vue&type=script&lang=ts"
export * from "./AEicon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports